export class LoadBasketRemoteStateAction {
  static type = '[BASKET] Load remote state';
}
